import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = {
  class: "input-group align-self-center ms-auto p-2 bd-highlight",
  style: {"width":"40%"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", {
  key: "100",
  value: ""
}, "全部", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  key: "100",
  value: ""
}, "全部", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  key: "1",
  value: "1"
}, "启用", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  key: "2",
  value: "0"
}, "禁用", -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "序号"),
    /*#__PURE__*/_createElementVNode("th", null, "房号"),
    /*#__PURE__*/_createElementVNode("th", null, "房型"),
    /*#__PURE__*/_createElementVNode("th", null, "门店"),
    /*#__PURE__*/_createElementVNode("th", null, "排序"),
    /*#__PURE__*/_createElementVNode("th", null, "显示"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_13 = { id: "member-list" }
const _hoisted_14 = { class: "mb-1 form-switch" }
const _hoisted_15 = ["checked", "onChange"]
const _hoisted_16 = { class: "flex-row flex-align-center" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_AddRoomDialog = _resolveComponent("AddRoomDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openAddRoomDialog && $setup.openAddRoomDialog(...args)))
          }, "添加")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select w-40",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shopId) = $event))
        }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.shopDataList, (value, idx) => {
            return (_openBlock(), _createElementBlock("option", {
              key: idx,
              value: value.id
            }, _toDisplayString(value.name), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.shopId]
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "form-select w-40",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.show) = $event))
        }, _hoisted_10, 512), [
          [_vModelSelect, _ctx.show]
        ]),
        _withDirectives(_createElementVNode("input", {
          style: {"left":"10px","right":"10px"},
          type: "text",
          id: "article-keywords",
          class: "form-control w-30",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.title) = $event)),
          placeholder: "房间号"
        }, null, 512), [
          [_vModelText, _ctx.title]
        ]),
        _createElementVNode("button", {
          class: "btn btn-secondary",
          type: "button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.searchRoom && $setup.searchRoom(...args)))
        }, "搜索")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("tbody", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.title), 1),
                _createElementVNode("td", null, _toDisplayString(value.roomType), 1),
                _createElementVNode("td", null, _toDisplayString(value.shopName ?? value.shop), 1),
                _createElementVNode("td", null, _toDisplayString(value.order), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      checked: value.show === 1,
                      onChange: ($event: any) => ($setup.updateRoom(value, 'show')),
                      type: "checkbox",
                      role: "switch"
                    }, null, 40, _hoisted_15)
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditRoomDialog(value))
                    }, null, 8, _hoisted_17),
                    _createElementVNode("img", {
                      class: "button-icon ml-5",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteRoom(value.id, value.title))
                    }, null, 8, _hoisted_18)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadRoomList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_AddRoomDialog, {
      show: _ctx.showAddDialog,
      room: _ctx.editing,
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddDialog = false)),
      onConfirm: $setup.editRoom
    }, null, 8, ["show", "room", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}